document.addEventListener("DOMContentLoaded", function () {
  /* =========================================================
     COLLAPSIBLE FACET HEADERS
     ========================================================= */
  const facetHeaders = document.querySelectorAll(".ais-facet--header");
  facetHeaders.forEach((header) => {
    header.addEventListener("click", () => {
      const content = header.nextElementSibling;
      header.classList.toggle("is-active");
      content.classList.toggle("active");
    });
  });

  /* =========================================================
     ALGOLIA SEARCH PLACEHOLDERS (Desktop + Mobile)
     ========================================================= */
  const desktopPlaceholder = "Search for products by SKU, name, etc.";
  const mobilePlaceholder = "Search for products by SKU, name, etc.";

  function updatePlaceholders() {
    const desktopInput = document.querySelector(".aa-Input");
    if (desktopInput && desktopInput.placeholder !== desktopPlaceholder) {
      desktopInput.placeholder = desktopPlaceholder;
    }

    const mobilePlaceholderEl = document.querySelector(".aa-DetachedSearchButtonPlaceholder");
    if (mobilePlaceholderEl && mobilePlaceholderEl.textContent.trim() !== mobilePlaceholder) {
      mobilePlaceholderEl.textContent = mobilePlaceholder;
    }
  }

  // Initial polling: Algolia initializes asynchronously
  const interval = setInterval(updatePlaceholders, 300);

  // Stop polling after 10 seconds
  setTimeout(() => clearInterval(interval), 10000);

  // Observe DOM for dynamic re-renders (Algolia updates)
  const observer = new MutationObserver(updatePlaceholders);
  observer.observe(document.body, { childList: true, subtree: true });

  function installAlgoliaQueryTransformer() {
      const searchInstance = window.algoliaShopify?.instantsearch?.search;

      if (!searchInstance || !searchInstance.helper) {
        return false;
      }

      const helper = searchInstance.helper;
      const originalSearch = helper.search;

      helper.search = function () {
        let q = helper.state.query;
        if (q) {
          const normalized = q.replace(/(\d+)x(\d+)/gi, "$1 x $2");
          if (normalized !== q) {
            //console.log("Query transformed:", q, "→", normalized);
            helper.setQuery(normalized);
          }
        }

        return originalSearch.apply(this, arguments);
      };
      //console.log("Algolia query transformer installed");
      return true;
  }

  // Try immediately
  if (installAlgoliaQueryTransformer()) return;

  let attempts = 0;
  const maxAttempts = 5;

  var algoliaRetryInterval = setInterval(() => {
    attempts++;

    if (installAlgoliaQueryTransformer() || attempts >= maxAttempts) {
      clearInterval(algoliaRetryInterval );
    }

  }, 300);
  
});
